import React, { useMemo } from "react";
import { ConnectionProvider, WalletProvider } from "@solana/wallet-adapter-react";

// Wallet Standard auto-discovery (Phantom, Solflare, Backpack…). The endpoint is only cluster context —
// all balance reads happen server-side so no RPC key ever reaches the browser.
export function SolanaProvider({ children }) {
  const endpoint = useMemo(() => "https://api.mainnet-beta.solana.com", []);
  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={[]} autoConnect={false}>{children}</WalletProvider>
    </ConnectionProvider>
  );
}
